import { api_GET, api_POST, api_PUT, api_DELETE, api_POST_Unauthorize } from "./_api.js";

const pgrss_api = {
    GetItem: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Pgrss/GetItem`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetTransportadoresPgrss: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Pgrss/GetTransportadoresPgrss`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Insert: (pgrss) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Pgrss/`, pgrss)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Update: (pgrss) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Pgrss/`, pgrss)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default pgrss_api;
